import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import { ZTooltip } from 'src/components/widgets/ztooltip';
import { getToolLabel, ProductSalesChannelInfo } from '../common/constants';
import {
    ChannelDisconnectButton,
    ChannelDot,
    ChannelItem,
    ChannelMeta,
    ChannelsBadge,
    ChannelsDropdown,
    ItemDot,
    ItemNameAction,
    PanelItemSpaced,
    StatusBadge,
    StatusBar,
    StatusBarSpacer,
    ToolBadge
} from '../common/styled';

export interface StatusBarSectionProps {
    zakekeEnvironment: string;
    isOnline: boolean;
    salesChannelCount: number;
    salesChannels: ProductSalesChannelInfo[];
    channelsOpen: boolean;
    onToggleChannels: () => void;
    onAddSalesChannel?: () => void;
    onDisconnectSalesChannel?: (channel: ProductSalesChannelInfo) => void;
}

export const StatusBarSection: FC<StatusBarSectionProps> = ({
    zakekeEnvironment,
    isOnline,
    salesChannelCount,
    salesChannels,
    channelsOpen,
    onToggleChannels,
    onAddSalesChannel,
    onDisconnectSalesChannel
}) => (
    <>
        {/* Status bar: tool + status + sales channels */}
        <StatusBar>
            <ToolBadge $type={zakekeEnvironment}>{getToolLabel(zakekeEnvironment)}</ToolBadge>
            <StatusBadge $online={isOnline}>{isOnline ? T._('Online', 'Admin') : T._('Not published', 'Admin')}</StatusBadge>
            <StatusBarSpacer />
            <ChannelsBadge $count={salesChannelCount} onClick={onToggleChannels}>
                {salesChannelCount > 0
                    ? salesChannelCount + ' ' + (salesChannelCount === 1 ? T._('Sales Channel', 'Admin') : T._('Sales Channels', 'Admin'))
                    : T._('No Sales Channels', 'Admin')}
                {salesChannelCount > 0 && <span>{channelsOpen ? '▴' : '▾'}</span>}
            </ChannelsBadge>
        </StatusBar>
        {/* Channels dropdown */}
        {channelsOpen && (
            <ChannelsDropdown>
                {salesChannels.map((salesChannel, channelIndex) => (
                    <ChannelItem key={channelIndex}>
                        <ChannelDot />
                        {salesChannel.url ? (
                            <ZTooltip position='top' title={salesChannel.url}>
                                <span>{salesChannel.name}</span>
                            </ZTooltip>
                        ) : (
                            <span>{salesChannel.name}</span>
                        )}
                        <ChannelMeta>{salesChannel.ecommerce}</ChannelMeta>
                        {salesChannel.isOtherSalesChannel && onDisconnectSalesChannel && (
                            <ChannelDisconnectButton onClick={() => onDisconnectSalesChannel(salesChannel)}>
                                {T._('Disconnect', 'Admin')}
                            </ChannelDisconnectButton>
                        )}
                    </ChannelItem>
                ))}
                {onAddSalesChannel && (
                    <PanelItemSpaced $clickable onClick={() => onAddSalesChannel()}>
                        <ItemDot $color='#d1d5db' />
                        <ItemNameAction>+ {T._('Add to a Sales Channel', 'Admin')}</ItemNameAction>
                    </PanelItemSpaced>
                )}
            </ChannelsDropdown>
        )}
    </>
);
